import React from 'react';
import { Box, Button, Dialog, IconButton, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import { useNavigate } from 'react-router-dom';
import FilledActionButton from 'components/FilledActionButton';
import { fmt } from 'pages/VocabularyTest/cefr';
import { pagePaths } from 'routes/paths';

interface TestResultAddedModalProps {
  open: boolean;
  wordsCount: number;
  onClose: () => void;
}

const TestResultAddedModal: React.FC<TestResultAddedModalProps> = ({
  open,
  wordsCount,
  onClose,
}) => {
  const navigate = useNavigate();

  return (
    <Dialog disableScrollLock open={open} onClose={onClose} maxWidth={'xs'} fullWidth>
      <Box sx={{ p: 4, textAlign: 'center', position: 'relative' }}>
        <IconButton
          onClick={onClose}
          aria-label={'Закрити'}
          sx={{ position: 'absolute', top: 14, right: 14, color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
        <Box
          sx={{
            width: 66,
            height: 66,
            borderRadius: '50%',
            bgcolor: 'primary.vocabularyActiveSpeech',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2.25,
          }}
        >
          <CheckIcon sx={{ fontSize: 38 }} />
        </Box>
        <Typography sx={{ fontSize: 24, fontWeight: 800, lineHeight: 1.2 }}>
          {'Слова додано у словник'}
        </Typography>
        <Typography sx={{ fontSize: 16, color: 'text.secondary', mt: 1 }}>
          {`Усі ${fmt(wordsCount)} слів тесту збережено. Тепер їх можна опрацювати у вправах на вивчення.`}
        </Typography>
        <Box sx={{ display: 'flex', gap: 1.5, mt: 3.25, flexWrap: 'wrap' }}>
          <Button
            variant={'outlined'}
            onClick={onClose}
            sx={{ flex: 1, minWidth: 130, height: 46 }}
          >
            {'Залишитись тут'}
          </Button>
          <FilledActionButton
            startIcon={<PlayArrowIcon />}
            onClick={() => navigate(`/${pagePaths.learning}`)}
            sx={{ flex: 1, minWidth: 130, height: 46, fontSize: 15 }}
          >
            {'Перейти до вправ'}
          </FilledActionButton>
        </Box>
      </Box>
    </Dialog>
  );
};

export default TestResultAddedModal;
